import env from 'utils/env';
export default function parseImage(image, placeholder = null) {
    return image ? `${env.static}/${image}` : placeholder;
}
